<template>
    <div>
        <div class="tool-bar mb10">
            <el-button type="primary" v-if="pageFuncNames.includes('add_level1_tag')" @click="showAdd1Modal"  size="mini" class="mr10">添加一级标签</el-button>
        </div>
        <div class="data-list">
            <jt-table
                v-loading="dataLoading"
                :data="dataList"
                row-key="id"
                :row-class-name="rowClassName"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="标签ID"
                    align="left"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="一级标签"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p v-if="scope.row.level=='1'" class="level_name relative" :title="scope.row.name">
                            <span class="ellipsis inline-block ver-middle" style="max-width: 70%;">{{scope.row.name||'--'}}</span>
                            <span @click="editRow(scope.row)" v-if="pageFuncNames.includes('edit_tag')" class="text-color-primary pointer el-icon-edit-outline ver-middle ml6 font16px text-bold"></span>
                        </p>
                        <span v-else></span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="name"
                    label="二级标签"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p v-if="scope.row.level=='2'" class="level_name relative" :title="scope.row.name">
                            <span class="ellipsis inline-block ver-middle" style="max-width: 70%;">{{scope.row.name||'--'}}</span>
                            <span @click="editRow(scope.row)" v-if="pageFuncNames.includes('edit_tag')" class="text-color-primary pointer el-icon-edit-outline ver-middle ml6 font16px text-bold"></span>
                        </p>
                        <span v-else>共{{(scope.row.children||[]).length}}个标签</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="describe"
                    label="说明"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    label="创建人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="ctime"
                    label="创建时间"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.ctime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="edit_name"
                    label="最新修改人"
                    align="center"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="mtime"
                    label="最新修改时间"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <p class="word-break">{{scope.row.mtime}}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="action"
                    label="操作"
                    align="center"
                    width="150">
                    <template slot-scope="scope">
                        <div class="tar">
                            <el-button v-if="pageFuncNames.includes('add_level2_tag')&&scope.row.level=='1'" @click="showAdd2Modal(scope.row)" type="text" class="text-color-primary mr10">添加标签</el-button>
                            <el-button v-if="pageFuncNames.includes('enable_tag')&&scope.row.is_delete=='1'" @click="enableRow(scope.row)" :loading="scope.row.enableLoading" type="text" class="text-color-primary mr10">启用</el-button>

                            <el-popconfirm
                                title="您确定要停用吗？"
                                confirm-button-text="停用"
                                confirm-button-type="danger"
                                v-if="pageFuncNames.includes('delete_tag')&&scope.row.is_delete!='1'"
                                @confirm="deleteRow(scope.row)">
                                <el-button slot="reference" :loading="scope.row.deleteLoading" type="text" class="text-color-error ml10 mr10">停用</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </jt-table>
        </div>
    </div>
</template>

<script>
    import API from '@/api/workOrder/conf.js';
    import {label1Modal,label2Modal} from '../modal/index';
    export default {
        name: "ImageTagList",
        props:{
            pageFunc:Array,
        },
        data(){
            return {
                dataLoading:false,
                dataList:[],
                type:'1',   // 1-图片，2-视频
            }
        },
        computed:{
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            showAdd1Modal(){
                console.log('showAdd1Modal');
                label1Modal({
                    props: {
                        type:this.type,   // 1-图片，2-视频
                        id:'',
                        data:{},
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            showAdd2Modal(row){
                console.log('showAdd2Modal',row);
                label2Modal({
                    props: {
                        id:'',
                        type:this.type,
                        pid:row.id,
                        data:{},
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：保存',data);
                            this.getDataList();
                        },
                    }
                })
            },
            getDataList(){
                console.log('getLabelConfigList');
                API.getImageLabelConfigList().then(res=>{
                    console.log('getLabelConfigList',res);
                    this.dataLoading = false;
                    let resData = res.data||[];
                    this.dataList = resData.map((item,index)=>{
                        item.level1Index = index;
                        item.level = '1';
                        item.deleteLoading = false;
                        item.enableLoading = false;
                        if(Array.isArray(item.children)&&item.children.length>0){
                            item.children = item.children.map(inner=>{
                                inner.deleteLoading = false;
                                inner.enableLoading = false;
                                inner.level = '2';
                                return inner;
                            })
                        }
                        return item;
                    });
                },err=>{
                    console.log('getLabelConfigList err',err)
                    this.dataLoading = false;
                })
            },
            enableRow(row){
                console.log('enableRow',row);
                row.enableLoading = true;
                API.enableImageLabelConfig({
                    id:row.id,
                }).then(res=>{
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    row.enableLoading = false;

                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'操作失败');
                })
            },
            deleteRow(row){
                console.log('deleteRow',row);
                row.deleteLoading = true;
                API.deleteImageLabelConfig({
                    id:row.id,
                }).then(res=>{
                    this.$message.success(res.info||'操作成功');
                    this.getDataList();
                },err=>{
                    row.deleteLoading = false;

                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info||'操作失败');
                })
            },
            editRow(row){
                console.log('editRow',row);
                let level = row.level;
                if(level=='1'){
                    label1Modal({
                        props: {
                            type:this.type,   // 1-图片，2-视频
                            id:row.id,
                            data:{
                                name:row.name,
                            },
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                console.log('onSubmit：保存',data);
                                this.getDataList();
                            },
                        }
                    })
                }else if(level=='2'){
                    label2Modal({
                        props: {
                            id:row.id,
                            type:this.type,
                            pid:row.pid,
                            data:{
                                name:row.name,
                                describe:row.describe,
                            },
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                console.log('onSubmit：保存',data);
                                this.getDataList();
                            },
                        }
                    })
                }
            },
            rowClassName({row}){
                if(row.level1Index){
                    return row.level1Index%2==0?'td-row-odd':'td-row-even';
                }else{
                    return row.level==2?'td-row-level2':'';
                }
            },
        },

    }
</script>

<style lang="scss" scoped>
    .level_name{
        line-height: 16px;
    }
    .data-list {
        ::v-deep .td-row-even{
            background-color: #fafafa;
        }
        ::v-deep .td-row-level2 {
            background-color: #F5F7FA;
        }
    }
    .word-break {
        word-break:break-word;
    }
</style>
